import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2zdmtoaf: FaireBrandEntity = {
  token: "b_2zdmtoaf",
  type: "brand",
  name: "The Handloom",
  avatarUrl:
    "https://cdn.faire.com/fastly/ebff1252cc6e802381a021ac86fb5e7aca4013b8aac0d1ca1f342bd8cf6bd604.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/67766ebcea1d3f0ec58edfe0e8321164b0344d58eefa0064bdf5407c13e05725.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ebff1252cc6e802381a021ac86fb5e7aca4013b8aac0d1ca1f342bd8cf6bd604.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/67766ebcea1d3f0ec58edfe0e8321164b0344d58eefa0064bdf5407c13e05725.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 300,
  rating: 4.9,
  reviewCount: 207,
  isTopShop: true,
  isInsider: true,
  description:
    "The Handloom offers a collection of ethical and sustainable fashion made from 100% Turkish Cotton, hand-loomed with meticulous attention to detail. Each garment is a testament to traditional craftsmanship and supports local artisans in Turkey's remote villages, sustaining their rich heritage. The collection includes a variety of dresses, kimonos, tops, pants, shorts, and skirts, all crafted with a focus on sustainability and empowering local communities.\nEmpowering women through ethical and sustainable craftsmanship, our luxury fabrics exemplify a commitment to elegance with environmental responsibility.\n\n*Shipping & Duties\n\nAll orders ship from our California warehouse.\n\nNo additional import duties or tariffs apply for U.S. retailers—no hidden costs.\n\n*Access Free Marketing Materials for Your Store\nYou can use our photos and videos as marketing materials for social media, online presence, and other promotional purposes. After your purchase, you can request access to our media library, and we will share the link with you.\n\nBy using our high-quality visuals, you can enhance your brand’s storytelling, create engaging content for your website and social media, and elevate your marketing efforts effortlessly. Showcase our products in the best light and connect with your customers in a visually compelling way!\n\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:37.934Z",
    importedBy: "entity-db-cli",
  },
};
